import { THREE, DEG2RAD, __DEFAULT_SMOOTH_TIME } from './context.js';

window.textObjs = {}

// Aggregate bubbles (level-1 package clusters + the level-2 hub / severity /
// host-group view) — few of them, rendered large, labels must read at default zoom.
const isAggregateNode = (node) =>
  node.group == "cluster" || node.group == "clusterHub" ||
  node.group == "severityGroup" || node.group == "hostGroup";

function get3dTextImpl(node, ccolor, font) {

  // Aggregate bubbles: big sphere, big centered label right underneath it, so the
  // name + count read at the default zoom.
  if (isAggregateNode(node)) {
    const r = (node.val || 14) * 0.66;
    const shapes = font.generateShapes(node.name, 8);
    const geometry = new THREE.ShapeGeometry(shapes);
    geometry.computeVertexNormals();
    geometry.computeBoundingBox();
    geometry.translate(-0.5 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x), 0, 0);
    const text = new THREE.Mesh(geometry, ccolor);
    text.position.set(0, -(r + 12), r * 0.4);
    return text;
  }

  let sizeVal = 1 + ((node.val || 1) * 0.12);
  let isHost = node.group == "host";
  const shapes = font.generateShapes(node.name, isHost ? 4.2 : sizeVal);
  const geometry = new THREE.ShapeGeometry(shapes);
  // ShapeGeometry has no normal attribute by default; the shared severity material
  // is a lit MeshStandardMaterial, which warns ("normal not found on geometry") without this.
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();
  const xMid = - 0.25 * (geometry.boundingBox.max.x - geometry.boundingBox.min.x);
  geometry.translate(xMid, 0, 0);

  const text = new THREE.Mesh(geometry, ccolor);
  text.position.z = isHost ? 1.4 : (sizeVal * 2 + 1)
  text.position.y = isHost ? -8.4 : -1 * ((sizeVal / 0.4 + 1)) //4
  text.position.x = isHost ? -2.4 : (-1 * (sizeVal * 3) + 1) //8
  return text
}

const get3dText = (node, ccolor, font) => {
  let id = `${node.name}-${ccolor}-${font}`
  if (typeof window.textObjs[id] !== "undefined") {
    return window.textObjs[id]
  } else {
    window.textObjs[id] = get3dTextImpl(node, ccolor, font)
    return window.textObjs[id]
  }

}

window.geomObjs = {}
function geom(radius, segments, segmentsHeight) {
  let id = `${radius}-${segments}-${segmentsHeight}`
  if (typeof window.geomObjs[id] !== "undefined") {
    return window.geomObjs[id]
  } else {
    window.geomObjs[id] = new THREE.SphereGeometry(radius, segments, segmentsHeight)
    return window.geomObjs[id]
  }
}

window.meshObjs = {}

var sphereMesh = function (node, dark, severityColors, font) {
  let isHost = node.group == "host";
  let isCluster = isAggregateNode(node);
  let bsize = (Math.max(2, (node.val || 2) * 0.212) || 4) * 2;

  let id = `${node.name}-${dark}-${severityColors}-${font}`

  // Always return a fresh Group: r3f-forcegraph empties a node's previous object before
  // re-attaching the one returned here, so handing back a cached Group gets its children
  // stripped right before it's re-added, leaving invisible empty groups. Only the Group is
  // fresh — the expensive mesh/geometry/text children stay cached below.
  let res = new THREE.Group();

  if (typeof window.meshObjs[id] === "undefined") {
    // Low segment count: these render as small marker dots, so high-poly spheres
    // (previously 32x32, ~2000 tris each) just waste GPU work across thousands of nodes.
    // Clusters are the exception: there are only a handful of them and they render
    // large, so they get a smooth high-segment sphere.
    window.meshObjs[id] = new THREE.Mesh(
      isCluster ?
        geom((node.val || 14) * 0.66, 24, 24)
        : !isHost ?
          geom(Math.max(2, (node.val || 2) * 0.212) || 4, 8, 8)
          : geom(bsize, 8, 8)
      ,
      severityColors[node?.data?.vulnerability?.severity?.toLowerCase() || "host"] || severityColors.unknown
    );
  }

  res.add(window.meshObjs[id]);
  // Cluster labels are identification, not severity signal (the sphere already carries
  // the color) — neutral label color keeps them readable at the default zoom.
  res.add(get3dText(node,
    isCluster ?
      (severityColors.host || severityColors.unknown)
      : severityColors[node?.data?.vulnerability?.severity?.toLowerCase() || "host"] || severityColors.unknown,
    font))

  res.name = node.name;
  return res
}

export { get3dText, geom, sphereMesh };
